module.exports = __webpack_public_path__ + "static/media/alarm-clock.b7ad2d70.svg";